import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_GET_BUSINESS_USER_DETAIL } from "../../../config/api";

export const getBusinessUserById = createAsyncThunk(
  "user/getBusinessUserById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await Client({
        method: "GET",
        path: `${API_GET_BUSINESS_USER_DETAIL}${id}`,
      });

      return data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
